import { useAlertPreview } from 'utils/hooks/alerts';

const getCadenceCopy = (cadence) => {
    const cadenceValue = String(cadence || 'weekly').toLowerCase();
    if (cadenceValue === 'monthly') {
        return { title: 'Monthly', period: 'month' };
    }
    return { title: 'Weekly', period: 'week' };
};

const getStaticPlaceholderSrcDoc = (
    { loading, cadence } = { loading: true, cadence: 'weekly' },
) => {
    const todayDate = new Date().toLocaleDateString('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
    });
    const { title } = getCadenceCopy(cadence);
    return `
    <!DOCTYPE html>
    <html lang="en">
    <head>
      <meta charset="UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <title>Preview Placeholder</title>
      <style>
      ${
          loading
              ? `
            @keyframes shimmer {
              0% { background-position: -1000px 0; }
              100% { background-position: 1000px 0; }
            }
            .skeleton {
              background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
              background-size: 1000px 100%;
              animation: shimmer 2s infinite linear;
              border-radius: 4px;
            }
        `
              : `
        .skeleton {
          background: #f0f0f0;
          border-radius: 4px;
        }
      `
      }
      </style>
    </head>
    <body style="margin:0; padding:2.5%; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif; background-color: #f5f5f5; color: #0f172a;">
      <!-- Main container -->
      <div style="max-width: 760px;margin: 0 auto;">
        <div style="background: #ffffff; border-radius: 18px; overflow: hidden; box-shadow: 0 10px 30px rgba(16,24,40,0.08); border: 1px solid #eef2ff;">

          <div style="padding:10px 12px; font-size:10px; line-height:16px; font-weight:700; color:#ffffff; background:#895EF6; border-radius:18px 18px 0 0;text-align:center;">
            ${title} trends update · ${todayDate}
          </div>

          <div style="text-align:center; padding: 5% 0; border-bottom:1px solid #7e7e7e;">
            <img height="40" width="170.6" style="height:5%;width:170.6px;" src="https://storage.googleapis.com/spate-186619/web_assets/images/black_logo.png" alt="Spate" />
          </div>

          <div style="padding: 5%;">
            <!-- Title -->
            <div class="skeleton" style="width: 40%; height: 32px; margin: 0 0 12px;"></div>

            <!-- Subtitle -->
            <div class="skeleton" style="width: 70%; height: 20px; margin: 0;"></div>
          </div>

          <div style="padding:5%;background:#ebe3fe;">
            <!-- Trend card -->
            <div style="background:white;border-radius:14px;padding:4% 5%;margin-bottom:5%;">
              <table style="width:100%;border-spacing:0;">
                <tr>
                  <td colspan="4" style="padding-bottom:2%;">
                    <div class="skeleton" style="width: 30%; height: 18px;"></div>
                  </td>
                </tr>
                <tr>
                  <td style="width:10%;vertical-align:top;">
                    <div class="skeleton" style="width: 30px; height: 30px; border-radius: 50%;"></div>
                  </td>
                  <td colspan="3" style="padding-left:3%;vertical-align:top;">
                    <div class="skeleton" style="width: 100%; height: 12px; margin-bottom: 6px;"></div>
                    <div class="skeleton" style="width: 90%; height: 12px;"></div>
                  </td>
                </tr>
              </table>
            </div>

            <!-- Trend card 2 -->
            <div style="background:white;border-radius:14px;padding:4% 5%;margin-bottom:5%;">
              <table style="width:100%;border-spacing:0;">
                <tr>
                  <td colspan="4" style="padding-bottom:2%;">
                    <div class="skeleton" style="width: 35%; height: 18px;"></div>
                  </td>
                </tr>
                <tr>
                  <td style="width:10%;vertical-align:top;">
                    <div class="skeleton" style="width: 30px; height: 30px; border-radius: 50%;"></div>
                  </td>
                  <td colspan="3" style="padding-left:3%;vertical-align:top;">
                    <div class="skeleton" style="width: 95%; height: 12px; margin-bottom: 6px;"></div>
                    <div class="skeleton" style="width: 85%; height: 12px;"></div>
                  </td>
                </tr>
              </table>
            </div>

            <!-- Trend card 3 -->
            <div style="background:white;border-radius:14px;padding:4% 5%;">
              <table style="width:100%;border-spacing:0;">
                <tr>
                  <td colspan="4" style="padding-bottom:2%;">
                    <div class="skeleton" style="width: 25%; height: 18px;"></div>
                  </td>
                </tr>
                <tr>
                  <td style="width:10%;vertical-align:top;">
                    <div class="skeleton" style="width: 30px; height: 30px; border-radius: 50%;"></div>
                  </td>
                  <td colspan="3" style="padding-left:3%;vertical-align:top;">
                    <div class="skeleton" style="width: 100%; height: 12px; margin-bottom: 6px;"></div>
                    <div class="skeleton" style="width: 92%; height: 12px;"></div>
                  </td>
                </tr>
              </table>
            </div>
          </div>

        </div>
      </div>
    </body>
    </html>
`;
};

const placeholderSrcDoc = `
    <!DOCTYPE html>
    <html lang="en">
    <head>
      <meta charset="UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <title>Loading Preview</title>
      <style>
        @keyframes shimmer {
          0% { background-position: -1000px 0; }
          100% { background-position: 1000px 0; }
        }
        .skeleton {
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
          background-size: 1000px 100%;
          animation: shimmer 2s infinite linear;
          border-radius: 4px;
        }
      </style>
    </head>
    <body style="margin:0; padding:2.5%; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif; background-color: #f5f5f5; color: #0f172a;">
      <!-- Main container -->
      <div style="max-width: 760px;margin: 0 auto;">
        <div style="background: #ffffff; border-radius: 18px; overflow: hidden; box-shadow: 0 10px 30px rgba(16,24,40,0.08); border: 1px solid #eef2ff;">

          <div style="padding:10px 12px; font-size:10px; line-height:16px; font-weight:700; color:#ffffff; background:#895EF6; border-radius:18px 18px 0 0;text-align:center;">
            CADENCE_TITLE trends update · DATE_PLACEHOLDER
          </div>

          <div style="text-align:center; padding: 5% 0; border-bottom:1px solid #7e7e7e;">
            <img height="40" width="170.6" style="height:5%;width:170.6px;" src="https://storage.googleapis.com/spate-186619/web_assets/images/black_logo.png" alt="Spate" />
          </div>

          <div style="padding: 5%;">
            <!-- Title -->
            <h1 style="font-size:32px; font-weight:800; margin: 0 0 12px; color: #000000;">
              TOP <span style="color:#6125F5;">Trends</span>
            </h1>

            <!-- Subtitle -->
            <p style="font-size:20px; color:#000000; margin:0;text-wrap:pretty;">
              Trends of the CADENCE_PERIOD for <b>BRAND_NAME_PLACEHOLDER</b>CATEGORY_PLACEHOLDER 🚀
            </p>
          </div>

          <div style="padding:5%;background:#ebe3fe;">
            <!-- Trend card -->
            <div style="background:white;border-radius:14px;padding:4% 5%;margin-bottom:5%;">
              <table style="width:100%;border-spacing:0;">
                <tr>
                  <td colspan="4" style="padding-bottom:2%;">
                    <div class="skeleton" style="width: 30%; height: 18px;"></div>
                  </td>
                </tr>
                <tr>
                  <td style="width:10%;vertical-align:top;">
                    <div class="skeleton" style="width: 30px; height: 30px; border-radius: 50%;"></div>
                  </td>
                  <td colspan="3" style="padding-left:3%;vertical-align:top;">
                    <div class="skeleton" style="width: 100%; height: 12px; margin-bottom: 6px;"></div>
                    <div class="skeleton" style="width: 90%; height: 12px;"></div>
                  </td>
                </tr>
              </table>
            </div>

            <!-- Trend card 2 -->
            <div style="background:white;border-radius:14px;padding:4% 5%;margin-bottom:5%;">
              <table style="width:100%;border-spacing:0;">
                <tr>
                  <td colspan="4" style="padding-bottom:2%;">
                    <div class="skeleton" style="width: 35%; height: 18px;"></div>
                  </td>
                </tr>
                <tr>
                  <td style="width:10%;vertical-align:top;">
                    <div class="skeleton" style="width: 30px; height: 30px; border-radius: 50%;"></div>
                  </td>
                  <td colspan="3" style="padding-left:3%;vertical-align:top;">
                    <div class="skeleton" style="width: 95%; height: 12px; margin-bottom: 6px;"></div>
                    <div class="skeleton" style="width: 85%; height: 12px;"></div>
                  </td>
                </tr>
              </table>
            </div>

            <!-- Trend card 3 -->
            <div style="background:white;border-radius:14px;padding:4% 5%;">
              <table style="width:100%;border-spacing:0;">
                <tr>
                  <td colspan="4" style="padding-bottom:2%;">
                    <div class="skeleton" style="width: 25%; height: 18px;"></div>
                  </td>
                </tr>
                <tr>
                  <td style="width:10%;vertical-align:top;">
                    <div class="skeleton" style="width: 30px; height: 30px; border-radius: 50%;"></div>
                  </td>
                  <td colspan="3" style="padding-left:3%;vertical-align:top;">
                    <div class="skeleton" style="width: 100%; height: 12px; margin-bottom: 6px;"></div>
                    <div class="skeleton" style="width: 92%; height: 12px;"></div>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </body>
    </html>
`;

const getCategoryPhrase = (categories, maxItems = 5) => {
    if (!Array.isArray(categories) || !categories.length) return '';

    const names = [];
    const seen = new Set();
    categories.forEach((cat) => {
        const name = (cat?.cat3 || cat?.cat2 || '').trim();
        const key = name.toLowerCase();
        if (!name || seen.has(key)) return;
        seen.add(key);
        names.push(name);
    });

    if (!names.length) return '';
    if (names.length === 1) return ` in the ${names[0]} category`;
    if (names.length <= maxItems)
        return ` in the ${names.join(' & ')} categories`;
    return ` in the ${names.slice(0, maxItems).join(' & ')} + ${names.length - maxItems} more categories`;
};

function GeneratedAlert({ alert, isLoading, brandName, categories }) {
    const { data: preview, isLoading: isLoadingPreview } = useAlertPreview(
        alert?.alert_id,
        {
            // prevent flickering when new preview loads in
            keepPreviousData: true,
        },
    );
    const currentDate = new Date().toLocaleDateString('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
    });
    const categoryText = getCategoryPhrase(categories);
    const { title: cadenceTitle, period: cadencePeriod } = getCadenceCopy(
        alert?.cadence,
    );

    if (!preview?.html_content && (isLoadingPreview || isLoading)) {
        const srcDoc =
            categoryText && brandName && currentDate
                ? placeholderSrcDoc
                      .replace('DATE_PLACEHOLDER', currentDate)
                      .replace('CADENCE_TITLE', cadenceTitle)
                      .replace('CADENCE_PERIOD', cadencePeriod)
                      .replace('BRAND_NAME_PLACEHOLDER', brandName)
                      .replace('CATEGORY_PLACEHOLDER', categoryText)
                : getStaticPlaceholderSrcDoc({
                      loading: true,
                      cadence: alert?.cadence,
                  });
        return (
            <iframe
                srcDoc={srcDoc}
                title={`Loading preview...`}
                sandbox="allow-same-origin"
                className="grow"
            />
        );
    }
    if (!preview?.html_content) {
        return (
            <iframe
                srcDoc={getStaticPlaceholderSrcDoc({
                    loading: false,
                    cadence: alert?.cadence,
                })}
                title={`Preview not available`}
                sandbox="allow-same-origin"
                className="grow"
            />
        );
    }
    return (
        <iframe
            srcDoc={preview.html_content}
            title={`Preview for ${alert?.name}`}
            sandbox="allow-same-origin"
            className="grow"
        />
    );
}

export default GeneratedAlert;
